module.exports = __webpack_public_path__ + "static/media/iphone.b7801def.png";